// Shared behaviours used across index.html and project.html

export const EMAIL = "adityakapse0222@gmail.com";

export function setYear() {
  const y = new Date().getFullYear();
  document.querySelectorAll("#year, .year-mobile").forEach((el) => (el.textContent = y));
}

// Custom arrow cursor, only on fine pointers (desktop)
export function initCursor() {
  const cursor = document.querySelector(".custom-cursor");
  if (!cursor) return;
  const fine = window.matchMedia("(pointer: fine)").matches;
  if (!fine) return;
  document.documentElement.classList.add("cursor-on");
  window.addEventListener(
    "mousemove",
    (e) => {
      cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    },
    { passive: true }
  );
}

// Mobile sidebar toggle
export function initHamburger() {
  const btn = document.getElementById("hamburger");
  const nav = document.getElementById("nav");
  if (!btn || !nav) return;
  btn.addEventListener("click", () => nav.classList.toggle("collapsed"));
  nav.querySelectorAll("a").forEach((a) =>
    a.addEventListener("click", () => {
      if (window.innerWidth < 1024) nav.classList.add("collapsed");
    })
  );
}

// Copy email to clipboard with a "Copied!" flash
export function initEmailCopy() {
  const trigger = document.getElementById("contactEmail");
  const done = document.getElementById("copyDone");
  if (!trigger) return;
  const copy = async (ev) => {
    ev.preventDefault();
    try {
      await navigator.clipboard.writeText(EMAIL);
    } catch {
      const t = document.createElement("textarea");
      t.value = EMAIL;
      document.body.appendChild(t);
      t.select();
      document.execCommand("copy");
      document.body.removeChild(t);
    }
    if (done) {
      done.classList.add("show");
      setTimeout(() => done.classList.remove("show"), 1400);
    }
  };
  trigger.addEventListener("click", copy);
}
